import moment from 'moment'
import { message } from 'antd'

const getValidRetrieveDate = dateStr => {
  if (dateStr === undefined || dateStr.trim().length === 0) return undefined
  return moment(dateStr).format('MM/DD/YYYY')
}

const getValidSubmitDate = dateStr => {
  if (dateStr === undefined || dateStr.trim().length === 0) return undefined
  return moment(dateStr).format('YYYY-MM-DD')
}

export const errorMessage = () => {
  message.error('Some error has occured')
}

export const getValidInverterGroupRetrieve = data => {
  // return data.map(d => ({
  //   ...d,
  //   commissionDate: d.commissionDate
  //     ? moment(d.commissionDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
  //     : undefined,
  //   effectiveDate: d.effectiveDate
  //     ? moment(d.effectiveDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
  //     : undefined,
  // }))
  return data
}

export const getValidInverterGroupSubmit = data => {
  return data.map(d => ({
    ...d,
    commissionDate: d.commissionDateStr
      ? moment(d.commissionDateStr, 'MM/DD/YYYY').format('YYYY-MM-DD')
      : undefined,
    effectiveDate: d.effectiveDateStr
      ? moment(d.effectiveDateStr, 'MM/DD/YYYY').format('YYYY-MM-DD')
      : undefined,
  }))
  // return invGroupData
}

export const getValidEventRetrieve = data => {
  const eventData = data.map(e => {
    const updatedEventData = e
    updatedEventData.causecode1 = e.extension.causecode1
    updatedEventData.causecode2 = e.extension.causecode2
    updatedEventData.causecode3 = e.extension.causecode3
    updatedEventData.causecode4 = e.extension.causecode4
    updatedEventData.causecode5 = e.extension.causecode5
    updatedEventData.causecode6 = e.extension.causecode6
    updatedEventData.causecode7 = e.extension.causecode7
    updatedEventData.causecode8 = e.extension.causecode8
    updatedEventData.causecode9 = e.extension.causecode9
    updatedEventData.causecode10 = e.extension.causecode10
    return updatedEventData
  })
  return eventData
}

export const getValidEventSubmit = data => {
  const eventData = data.map(e => {
    const updatedEventData = {
      ...e,
      extension: {
        entityId: e.entityId,
        plantId: e.plantId,
        eventId: e.eventId,
        causecode1: e.causecode1,
        causecode2: e.causecode2,
        causecode3: e.causecode3,
        causecode4: e.causecode4,
        causecode5: e.causecode5,
        causecode6: e.causecode6,
        causecode7: e.causecode7,
        causecode8: e.causecode8,
        causecode9: e.causecode9,
        causecode10: e.causecode10,
      },
    }

    delete updatedEventData.causecode1
    delete updatedEventData.causecode2
    delete updatedEventData.causecode3
    delete updatedEventData.causecode4
    delete updatedEventData.causecode5
    delete updatedEventData.causecode6
    delete updatedEventData.causecode7
    delete updatedEventData.causecode8
    delete updatedEventData.causecode9
    delete updatedEventData.causecode10
    return updatedEventData
  })
  return eventData
}

export const getValidPlantRetrieve = data => {
  const plantData = data.map(e => {
    const updatedPlantData = e
    updatedPlantData.effectiveDate = getValidRetrieveDate(
      updatedPlantData.effectiveDate
    )
    return updatedPlantData
  })
  return plantData
}

export const getValidPlantSubmit = data => {
  const plantData = data.map(e => {
    const updatedPlantData = e
    updatedPlantData.effectiveDate = getValidSubmitDate(
      updatedPlantData.effectiveDate
    )
    return updatedPlantData
  })
  return plantData
}

export const getValidEnergyStorageRetrieve = data => {
  const energyStorageData = data.map(e => {
    const updatedEnergyStorageData = e
    updatedEnergyStorageData.commisionDate = getValidRetrieveDate(
      updatedEnergyStorageData.commisionDate
    )
    updatedEnergyStorageData.effectiveDate = getValidRetrieveDate(
      updatedEnergyStorageData.effectiveDate
    )
    return updatedEnergyStorageData
  })
  return energyStorageData
}

export const getValidEnergyStorageSubmit = data => {
  const energyStorageData = data.map(e => {
    const updatedEnergyStorageData = e
    updatedEnergyStorageData.commisionDate = getValidSubmitDate(
      updatedEnergyStorageData.commisionDate
    )
    updatedEnergyStorageData.effectiveDate = getValidSubmitDate(
      updatedEnergyStorageData.effectiveDate
    )
    return updatedEnergyStorageData
  })
  return energyStorageData
}
